import { useMemo } from 'react';
import { useAuthStore } from '../stores/auth.store';
import { resolveDatePreset, type DateRangeValue } from '../utils/date-presets';
import { resolveTrackingDefaults, type ResolvedTrackingDefaults } from '../utils/user-settings';

export interface ReportDefaults extends ResolvedTrackingDefaults {
  dateRange: DateRangeValue;
}

/**
 * The signed-in user's report defaults.
 *
 * Reads the persisted auth store rather than fetching, and that is load-bearing:
 * `useUrlState` freezes each param's default on first render, so defaults arriving
 * one render late would be wrong for the whole mount. localStorage is synchronous.
 */
export function useReportDefaults(): ReportDefaults {
  const settings = useAuthStore((s) => s.user?.settings);

  return useMemo(() => {
    const resolved = resolveTrackingDefaults(settings);
    return { ...resolved, dateRange: resolveDatePreset(resolved.datePreset) };
  }, [settings]);
}
